import Snaploader from './snaploader'

export default Snaploader
